import { TBooleanInNumber } from '~/types/main';

export enum ConnectionService {
  Unifonic = 'unifonic',
  Msegat = 'msegat',
}

export const connectionServiceCast = (data: any) => ({
  type: String(data.title) as ConnectionService,
  status: Number(data.status) as TBooleanInNumber,
  priority: String(data.priority),
  senderName: String(data.sender_name),
  userName: String(data.user_name),
  apiKey: String(data.credentials.api_key),
  apiUrl: String(data.credentials.api_url),
});

export type TakerConnectService = ReturnType<typeof connectionServiceCast>;

export type TakerConnectServices = Map<ConnectionService, TakerConnectService>;

export interface TakerConnectValidationErrors {
  senderName: string | null;
  userName: string | null;
}
